import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import MAIN_PATHS from "../../../../mainPaths";
import { THEME_FIELDS } from "../fields";
import { ITheme } from "../type";

export const initialThemeState: ITheme = {
	[THEME_FIELDS.STATE]: THEME_FIELDS.LIGHT,
};

export const themeSlice = createSlice({
	name: `${MAIN_PATHS.THEME}Container`,
	initialState: initialThemeState,
	reducers: {
		changeTheme(state, action: PayloadAction<ITheme>) {
			return {
				...state,
				...action.payload,
			};
		},
	},
});

export const themeActions = themeSlice.actions;
export const themeReducer = themeSlice.reducer;
